function readQboCallbackSearch(): string | undefined {
  if (typeof window === 'undefined') return undefined;

  const search = window.location.search.replace(/^\?/, '');
  const params = new URLSearchParams(search);
  return params.has('code') && params.has('realmId') ? search : undefined;
}

let initialQboCallbackSearch = readQboCallbackSearch();

/** The page-load query exactly as Intuit sent it, before TanStack rewrites the URL. Returned once. */
export function consumeInitialQboCallbackSearch(): string | undefined {
  const callbackSearch = initialQboCallbackSearch;
  initialQboCallbackSearch = undefined;
  return callbackSearch;
}
